import { Injectable } from "@angular/core";
import { CanMatch, Router, UrlTree } from "@angular/router";
import { PermissionCheckerService } from "./services/permission/permission-checker.service";

/**
 * Module-level persona guard for the accountant product area — mirror of
 * {@link ClientGuard}. No single catalog capability maps to "the whole
 * accountant module", so (per NUC-269) this is role-gated; every ACTION inside
 * the area is still capability/ownership gated at the API.
 */
@Injectable({ providedIn: 'root' })
export class AccountantGuard implements CanMatch {

  constructor(private router: Router, private permissionChecker : PermissionCheckerService) {}

  canMatch(): boolean | UrlTree {
    if (this.permissionChecker.hasRoleAccountant()) {
      return true;
    }
    return this.router.createUrlTree(['/access-denied']);
  }

}
